import { format_routes } from '@/utils/tools';
import { lazy } from 'react';


const AllocationMarketRate = lazy(() => import('../pages/allocations/market/rate'));
const AllocationMarketExternalPrice = lazy(() => import('../pages/allocations/market/externalPrice'));
const AllocationMarketListPrice = lazy(() => import('../pages/allocations/market/listPrice'));
const AllocationsCenterMarket = lazy(() => import('../pages/allocations/center/market'));
const AllocationsCenterPoultryMarket = lazy(() => import('../pages/allocations/center/poultryMarket'));
const AllocationsCenterMarketDelivery = lazy(() => import('../pages/allocations/center/delivery'));
const AllocationsCenterMarketPoultryDelivery = lazy(() => import('../pages/allocations/center/poultryDelivery'));
// const AllocationsCenterDemand = lazy(() => import('../pages/allocations/centerDemand'));
const AllocationsCenterTask = lazy(() => import('../pages/allocations/center/task'));
const AllocationsCenterPoultryTask = lazy(() => import('../pages/allocations/center/poultryTask'));
const AllocationsCenterTaskDetail = lazy(() => import('../pages/allocations/center/taskDetail'));
const AllocationsCenterPoultryTaskDetail = lazy(() => import('../pages/allocations/center/poultryTaskDetail'));
const AllocationsCenterPurchasePrice = lazy(() => import('../pages/allocations/center/purchasePrice'));
const AllocationsCenterSupplierPrice = lazy(() => import('../pages/allocations/center/supplierPrice'));
const AllocationDashboardInventoryBoard = lazy(() => import('../pages/allocations/dashboard/inventory'));
const AllocationDashboardPriceBoard = lazy(() => import('../pages/allocations/dashboard/price'));
const AllocationsSuggestFactory = lazy(() => import('../pages/allocations/suggest/factory'));

export const allocationsCenterChildrenRouter = [
  {
    path: '/allocations/center/market',
    element: <AllocationsCenterMarket />,
    key: 'allocationsCenterMarket',
    parentKey: 'allocationsCenter',
    label: 'Pork Delivery Market', //交割大盘
  },
  {
    path: '/allocations/center/market/delivery',
    element: <AllocationsCenterMarketDelivery />,
    key: 'allocationsCenterMarketDelivery',
    parentKey: 'allocationsCenter',
    label: 'Current Delivery Suggestions', //本期交割建议
  },
  {
    path: '/allocations/center/task',
    element: <AllocationsCenterTask />,
    key: 'allocationsTask',
    parentKey: 'allocationsTask',
    label: 'Pork Task List', //任务列表
  },
  {
    path: '/allocations/center/purchasePrice',
    element: <AllocationsCenterPurchasePrice />,
    key: 'allocationsCenterPurchasePrice',
    parentKey: 'allocationsCenterPurchasePrice',
    label: 'Buyer Prices', //需求方价格
  },
  {
    path: '/allocations/center/supplierPrice',
    element: <AllocationsCenterSupplierPrice />,
    key: 'allocationsCenterSupplierPrice',
    parentKey: 'allocationsCenterSupplierPrice',
    label: 'Supplier Prices', //供应方价格
  },
  {
    path: '/allocations/center/task/detail',
    element: <AllocationsCenterTaskDetail />,
    key: 'allocationsCenterTaskDetail',
    parentKey: 'allocationsCenterTaskDetail',
    label: '任务列表详情', //任务列表详情
    hidden: true,
  },
  {
    path: '/allocations/center/poultryMarket',
    element: <AllocationsCenterPoultryMarket />,
    key: 'allocationsCenterPoultryMarket',
    parentKey: 'allocationsCenter',
    label: 'Poultry delivery market​', //禽肉交割大盘
  },
  {
    path: '/allocations/center/poultryTask',
    element: <AllocationsCenterPoultryTask />,
    key: 'allocationsPoultryTask',
    parentKey: 'allocationsTask',
    label: 'Poultry Task List', //任务列表
  },
  {
    path: '/allocations/center/poultryTask/detail',
    element: <AllocationsCenterPoultryTaskDetail />,
    key: 'allocationsCenterPoultryTaskDetail',
    parentKey: 'allocationsCenterTaskDetail',
    label: '禽肉任务列表详情', //任务列表详情
    hidden: true,
  },
  {
    path: '/allocations/center/poultryMarket/delivery',
    element: <AllocationsCenterMarketPoultryDelivery />,
    key: 'allocationsCenterMarketPoultryDelivery',
    parentKey: 'allocationsCenter',
    label: '禽肉本期交割建议', //交割大盘
  }
];
export const allocationsSuggestChildrenRouter = [
  {
    path: '/allocations/suggest/factory',
    element: <AllocationsSuggestFactory />,
    key: 'allocationsSuggestFactory',
    parentKey: 'AllocationsSuggest',
    label: 'Factory to War Zone', //工厂到战区
  }
];
export const allocationMarketChildrenRouter = [
  {
    path: '/allocations/market/rate',
    element: <AllocationMarketRate />,
    key: 'allocationMarketRate',
    parentKey: 'allocationsMarket',
    label: 'Pork Yield Rate', //猪出品率
  },
  {
    path: '/allocations/market/listPrice',
    element: <AllocationMarketListPrice />,
    key: 'allocationMarketListPrice',
    parentKey: 'allocationsMarket',
    label: 'Daily Price Bulletin​', //调配-每日牌价
  },
  {
    path: '/allocations/market/externalPrice',
    element: <AllocationMarketExternalPrice />,
    key: 'allocationMarketExternalPrice',
    parentKey: 'allocationsMarket',
    label: 'External Market Price', //外部市场价格
    // hidden: true,
  },
];
export const allocationDashboardChildrenRouter = [
  {
    path: '/allocations/dashboard/inventoryBoard',
    element: <AllocationDashboardInventoryBoard />,
    key: 'allocationsDashboardInventory',
    parentKey: 'allocationsDashboard',
    label: 'Inventory Dashboard', //库存看板
  },
  {
    path: '/allocations/dashboard/priceBoard',
    element: <AllocationDashboardPriceBoard />,
    key: 'allocationsDashboardPrice',
    parentKey: 'allocationsDashboard',
    label: 'Price Dashboard', //价格看板
  },
];

export const allocationsRouter = [
  {
    path: '/allocations/center',
    element: '',
    key: 'allocationsCenter',
    label: 'Allocations Center', //猪调配中心,
    parentKey: 'AllocationsIndex',
    children: allocationsCenterChildrenRouter
  },
  {
    path: '/allocations/suggest',
    element: '',
    key: 'allocationsSuggest',
    label: 'Allocations Suggest', //调配建议,
    parentKey: 'AllocationsIndex',
    children: allocationsSuggestChildrenRouter
  },
  {
    path: '/allocations/market',
    element: '',
    key: 'allocationsMarket',
    label: 'Allocations Market', //全国猪肉行情,
    parentKey: 'AllocationsIndex',
    children: allocationMarketChildrenRouter
  },
  {
    path: '/allocations/dashboard',
    element: '',
    key: 'allocationsDashboard',
    label: 'Allocations Dashboard', //内部数据看版,
    parentKey: 'AllocationsIndex',
    children: allocationDashboardChildrenRouter
  },
];
export const format_allocations_router_routes = format_routes(allocationsRouter);